import { closeDrawer } from '../drawers'
import { visitorClientProvider } from '../websocketClient'
import type { TicketFormValues } from './types'

export const submitTicketForm = async (values: TicketFormValues) => {
	const client = visitorClientProvider.getClient()

	await client.chatTicketFormFinish(values)
	closeDrawer()
}
